// FLEXX Super App v3 — Flashcard decks + spaced-repetition intervals
// Review intervals (days): 3, 7, 14, 30 after initial seeding

export const SR_INTERVALS_DAYS = [3, 7, 14, 30];
export const DAY_MS = 86400000;

export const DECKS = [
  {
    id: "market",
    name: "Market Structure",
    color: "#01696f",
    cards: [
      { id: "m1", q: "What is a Higher High (HH)?", a: "A price peak that exceeds the previous peak, confirming an uptrend." },
      { id: "m2", q: "What is Break of Structure (BOS)?", a: "When price closes beyond a key swing high or low, signaling a potential trend shift." },
      { id: "m3", q: "Define 'liquidity sweep'.", a: "When price temporarily breaks a key level to trigger stop orders before reversing." },
      { id: "m4", q: "Define support.", a: "A price level where buying interest historically steps in, causing price to bounce upward." },
      { id: "m5", q: "What signals a confirmed downtrend?", a: "A sequence of lower highs and lower lows." },
    ],
  },
  {
    id: "ta",
    name: "Technical Analysis",
    color: "#C9A227",
    cards: [
      { id: "ta1", q: "What does RSI above 70 indicate?", a: "Overbought conditions — potential pullback or reversal zone. Use as a warning, not a trigger." },
      { id: "ta2", q: "What is a golden cross?", a: "When the 50 MA crosses above the 200 MA — classical bullish signal." },
      { id: "ta3", q: "Define divergence.", a: "When price makes a new high/low but the indicator does not confirm — signals weakening momentum." },
      { id: "ta4", q: "What does MACD measure?", a: "Momentum via the difference between two moving averages and its signal line; helps spot momentum shifts." },
      { id: "ta5", q: "Why do traders use multiple timeframes?", a: "Higher timeframes give bias and context; lower timeframes give precise entries aligned with that bias." },
    ],
  },
  {
    id: "risk",
    name: "Risk Management",
    color: "#a12c7b",
    cards: [
      { id: "r1", q: "Formula for forex position size?", a: "Lot Size = (Account Balance × Risk %) ÷ (Stop Loss in pips × Pip Value)." },
      { id: "r2", q: "What is the 2% rule?", a: "Never risk more than 2% of your total account balance on a single trade." },
      { id: "r3", q: "Formula for expectancy.", a: "(Win Rate × Avg Win) − (Loss Rate × Avg Loss). Positive = profitable system." },
      { id: "r4", q: "What is drawdown?", a: "Peak-to-trough decline of an account before a new peak is made." },
      { id: "r5", q: "What is 'portfolio heat'?", a: "Total risk across all currently open trades, summed. Keep it bounded (e.g., 4–6% for beginners)." },
    ],
  },
  {
    id: "psychology",
    name: "Psychology",
    color: "#6daa45",
    cards: [
      { id: "p1", q: "What is FOMO in trading?", a: "Fear Of Missing Out — entering a trade late out of emotion, not logic." },
      { id: "p2", q: "What is revenge trading?", a: "Placing impulsive trades to recover losses immediately — almost always makes things worse." },
      { id: "p3", q: "Trader's most important edge?", a: "Consistency and discipline in following your rules — not just the strategy itself." },
      { id: "p4", q: "Best first reaction to a loss?", a: "Review whether the trade followed your plan, log the lesson, then move on." },
      { id: "p5", q: "Why keep a trading journal?", a: "It converts noisy experience into data you can act on and improve." },
    ],
  },
];

export const ALL_CARDS = DECKS.flatMap((d) => d.cards.map((c) => ({ ...c, deckId: d.id, deckName: d.name, color: d.color })));
export const CARD_BY_ID = Object.fromEntries(ALL_CARDS.map((c) => [c.id, c]));

// Compute next due timestamp for a given interval index
export const dueAtFor = (intervalIdx, from = Date.now()) => {
  const idx = Math.max(0, Math.min(SR_INTERVALS_DAYS.length - 1, intervalIdx));
  return from + SR_INTERVALS_DAYS[idx] * DAY_MS;
};
